import React, { FunctionComponent, useState } from 'react'
import styles from './TaskPicker.module.sass'
import ShadowContainer from '../../../popover/ShadowContainer/ShadowContainer'
import { ID } from '../../../../../types/UtilityTypes'
import { useRootSelector } from '../../../../../utils/hooks'
import { taskLinesSelector, tasksSelector } from '../../../../../utils/selectors'
import { Task, taskStatusToColor } from '../../../../../responses/tasks'
import { conditionToggle, entityElem } from '../../../../../utils/entity-utils'
import Button from '../../../../controls/Button/Button'
import clsx from 'clsx'
import Popover from '../../../Popover'
import ChevronRightIcon from 'files/chevron/right.svg'
import { Classes, Colors } from '../../../../../styles'
import { Checkbox } from '../../../../controls/Checkbox/Checkbox'
import Group from '../../../Group/Group'
import { groupBy, head } from 'fp-ts/NonEmptyArray'
import { lineDeclination, taskDeclination } from '../../../../../utils/utils'
import { pipe } from 'fp-ts/function'
import { keys } from 'fp-ts/Record'
import Ellipsis from '../../../Ellipsis/Ellipsis'

interface Props {
    objectId: ID,
    tasksId: ID[],
    onChange: (tasks: Task[]) => void,
}

const TaskPicker: FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)
    const tasks = useRootSelector(tasksSelector(props.tasksId))
    const lines = useRootSelector(taskLinesSelector(props.objectId))

    const linesCount = pipe(
        tasks,
        groupBy((task: Task) => (task.parent_id || task.id).toString()),
        keys,
    ).length

    return <Popover
        isOpen={open}
        onClickOutside={() => setOpen(false)}
        positions={['bottom']}
        content={state => <ShadowContainer height={600} className={styles.popover} state={state}>
            {
                lines.map((line, index) => <div key={head(line).id}>
                    <Group
                        className={styles.group}
                        header={<div className={styles.header}>Линия задач {index + 1}</div>}
                        headerHeight={18}
                    >
                        {
                            line.map(task => <Checkbox
                                key={task.id}
                                color={taskStatusToColor(task.status_id)}
                                value={entityElem(task, tasks)}
                                onChange={active => props.onChange(conditionToggle(active, task)(tasks))}
                            >
                                {task.type.name}
                            </Checkbox>)
                        }
                    </Group>
                </div>)
            }
        </ShadowContainer>}
    >
        <Button
            color={Colors.blue}
            onClick={() => setOpen(!open)}
        >
            <Ellipsis>{taskDeclination(props.tasksId.length)} из {lineDeclination(linesCount)}</Ellipsis>
            <ChevronRightIcon className={clsx({[Classes.flip]: open})}/>
        </Button>
    </Popover>
}

export default TaskPicker